'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { Formik, Form, FormikHelpers } from 'formik';
import { initialValues, formSchema, FormSchema } from './form-schema';
import { useMutation } from '@apollo/client/react';
import { SendPasswordResetEmailDocument } from '@gql';
import { routes } from '@routes';
import { FormikInput } from '@components/form/formik-input';
import { Button } from '@components/button';
import { Typography } from '@components/typography';
import { Link } from '@components/link';
type Props = {};
export const PasswordForgot: React.FC<Props> = () => {
  const $ = _c(11);
  const [message, setMessage] = React.useState(undefined);
  const [sendPasswordResetEmailMutation] = useMutation(SendPasswordResetEmailDocument);
  let t0;
  if ($[0] !== sendPasswordResetEmailMutation) {
    t0 = async (t1, formikHelpers) => {
      const {
        email
      } = t1;
      await sendPasswordResetEmailMutation({
        variables: {
          input: {
            email
          }
        }
      });
      setMessage("Password reset email has been sent.");
      formikHelpers.resetForm();
    };
    $[0] = sendPasswordResetEmailMutation;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onSubmitProcedure = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-center space-y-3"><Typography variant="title2" component="h1" className="text-primary-main">Reset your password</Typography><Typography variant="body2" component="p" className="text-primary-main/70">Enter the email associated with your account and we'll send you a link to reset your password.</Typography></div>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== message) {
    t2 = t3 => {
      const {
        isSubmitting
      } = t3;
      return <Form className="space-y-6">{message && <div className="rounded-xl border-[1.5px] border-success-main bg-success-main/10 px-4 py-3 text-center text-sm font-medium text-primary-main">{message}</div>}<FormikInput label="Email" name="email" type="email" /><Button isFullWidth={true} type="submit" disabled={isSubmitting} isLoading={isSubmitting} className="text-base">Send Reset Link</Button></Form>;
    };
    $[3] = message;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onSubmitProcedure || $[6] !== t2) {
    t3 = <Formik initialValues={initialValues} validationSchema={formSchema} onSubmit={onSubmitProcedure}>{t2}</Formik>;
    $[5] = onSubmitProcedure;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="text-center"><Link to={routes.login} className="text-sm font-semibold text-primary-main underline underline-offset-2 hover:text-secondary-main transition-colors">Back to log in</Link></div>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3) {
    t5 = <div className="flex flex-col items-center justify-center px-4 py-16 sm:py-24"><div className="w-full max-w-md space-y-8">{t1}{t3}{t4}</div></div>;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};